



































import { mapState } from "vuex";

import { Component, Vue, Watch } from "vue-property-decorator";

import { Route } from "vue-router";
import { Tenant } from "@/interfaces/tenants";

import { TenantApiClient } from "@/api/tenant_client";
import VideoContent from "@/components/VideoContent.vue";

interface Upload {
  file?: File;
  isLoading: boolean;
  accept: string;
}

@Component({
  computed: {
    ...mapState(["tenants", "contents"])
  },
  components: { VideoContent }
})
export default class TenantVideoDetails extends Vue {
  // Mapped from vuex
  tenants!: Tenant[];
  contents!: any;

  // Other Variables
  private api = new TenantApiClient();

  public breadcrumbs: any[] = [];
  public isLoading = true;

  public data = {
    content: {} as any,
    original: {} as any,
    tenant: {} as any
  };

  mounted() {
    this.setTenant(this.$route.params.tenant_id);
    this.setContent(this.$route.params.content_id);
  }

  // Watchers
  @Watch("$route")
  onRouteChange(newValue: Route) {
    this.setTenant(newValue.params.tenant_id);
    this.setContent(newValue.params.content_id);
  }

  setContent(contentId: string) {
    this.data.original = this.contents[contentId];
    // Make a copy so we don't change the store + know what has been changed
    this.data.content = JSON.parse(JSON.stringify(this.data.original));

    this.$store.commit("pushBreadcrumbs", {
      label: "Video Details"
    });
  }

  setTenant(tenantId: string) {
    this.tenants.forEach(tenant => {
      if (tenant.tenant_id === tenantId) {
        this.data.tenant = tenant;

        this.$store.commit("clearBreadcrumbs");
        this.$store.commit("pushBreadcrumbs", {
          to: `/tenant/${tenantId}`,
          label: tenant.name
        });
        this.$store.commit("pushBreadcrumbs", {
          to: `/tenant/${tenantId}/videos`,
          label: "Videos"
        });
      }
    });
  }

  reset() {
    this.data.content = JSON.parse(JSON.stringify(this.data.original));
  }

  deleteContent() {
    this.$buefy.dialog.confirm({
      title: "Video löschen",
      message: "Bist du sicher, dass du dieses Video löschen möchtest?",
      confirmText: "Video Löschen",
      type: "is-danger",
      hasIcon: true,
      onConfirm: async () => {
        await this.api.deleteContent(
          this.data.tenant.tenant_id,
          this.data.content.content_id
        );

        this.contents[this.data.content.content_id] = undefined;
        await this.$router.push(`/tenant/${this.data.tenant.tenant_id}/videos`);
        this.$buefy.toast.open("Video gelöscht.");
      }
    });
  }

  async save() {
    try {
      const newContent = await this.api.saveContent(
        this.data.tenant.tenant_id,
        this.data.content
      );

      this.contents[newContent.content_id] = newContent;
      this.data.original = this.contents[newContent.content_id];
      this.data.content = JSON.parse(JSON.stringify(this.data.original));

      this.$buefy.toast.open({
        message: "Content updated.",
        type: "is-info",
        queue: false
      });
    } catch (e) {
      this.$buefy.toast.open({
        message: "Problem updating content.",
        type: "is-danger",
        queue: false
      });
    }
  }
}
